<div class="d-flex">
    <ul
        ngbNav
        #nav="ngbNav"
        [(activeId)]="active"
        class="nav-tabs"
        orientation="vertical"
    >
        <li [ngbNavItem]="1">
            <a ngbNavLink>Buttons</a>
            <ng-template ngbNavContent>
                <div class="d-flex flex-column">
                    <div *ngFor="let button of buttons">
                        <h3 class="mt-4">{{ button.label }}</h3>
                        <app-button
                            [label]="button.label"
                            [classes]="button.classes"
                            [hint]="button.hint"
                            [actionCallback]="button.actionCallback"
                            [disabled]="button.disabled"
                        ></app-button>
                    </div>

                    <h3 class="mt-4">dynamic danger</h3>
                    <app-button
                        label="button"
                        [classes]="['btn-danger']"
                    ></app-button>

                    <h3 class="mt-4">dynamic disabled</h3>
                    <app-button label="button" [disabled]="true"></app-button>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="2">
            <a ngbNavLink>Tables</a>
            <ng-template ngbNavContent>
                <!-- <app-data-table [tableData]="table9c"></app-data-table> -->

                <br />
                <hr />
                <br />
                <!-- <app-data-table [tableData]="table6a"></app-data-table> -->

                <br />
                <hr />
                <br />

                <!-- <app-data-table [tableData]="table4a"></app-data-table> -->

                <br />
                <hr />
                <br />

                <!-- config should be fixed, check notary transaction content -->
                <!-- <app-section-title imgPath={{imgPath}} altText={{altText}} title={{sectionTitle}}></app-section-title> -->

                <br />
                <hr />
                <br />

                <!-- config should be fixed, check notary transaction content -->
                <!-- <app-info-table [tableData]="table1Data" [background]="whiteBg"></app-info-table> -->

                <br />
                <hr />
                <br />

                <!-- config should be fixed, check notary transaction content -->
                <!-- <app-info-table [tableData]="table3Data" [background]="whiteBgBlueRows"></app-info-table> -->

                <br />
                <hr />
                <br />

                <!-- config should be fixed, check notary transaction content -->
                <!-- <app-info-table [tableData]="table3Data" [background]="grayBg"></app-info-table> -->

                <br />
                <hr />
                <br />

                <app-tab-panel></app-tab-panel>

                <br />
                <hr />
                <br />

                <app-form-input-group></app-form-input-group>
                <br />
                <hr />
                <br />
            </ng-template>
        </li>
        <li [ngbNavItem]="3">
            <a ngbNavLink>Pages</a>
            <ng-template ngbNavContent>
                <ul>
                    <li>
                        <a
                            [routerLink]="['/terms-conditions']"
                            routerLinkActive="router-link-active"
                            target="_blank"
                            rel="noopener noreferrer"
                            >terms-conditions (2)</a
                        >
                    </li>
                    <li>
                        <a
                            [routerLink]="['/profile-selection']"
                            routerLinkActive="router-link-active"
                            target="_blank"
                            rel="noopener noreferrer"
                            >profile-selection (3)</a
                        >
                    </li>
                    <li>
                        <a
                            [routerLink]="['/notary-info']"
                            routerLinkActive="router-link-active"
                            target="_blank"
                            rel="noopener noreferrer"
                            >notary-info (4a)</a
                        >
                    </li>
                    <li>
                        <a
                            [routerLink]="['/notary-report']"
                            routerLinkActive="router-link-active"
                            target="_blank"
                            rel="noopener noreferrer"
                            >notary-report (6b)</a
                        >
                    </li>
                    <li>
                        <a
                            [routerLink]="['/notary-transaction-content']"
                            routerLinkActive="router-link-active"
                            target="_blank"
                            rel="noopener noreferrer"
                            >notary-transaction-content (6a kaek)</a
                        >
                    </li>
                    <li>
                        <a
                            [routerLink]="['/notary-transaction-contract']"
                            routerLinkActive="router-link-active"
                            target="_blank"
                            rel="noopener noreferrer"
                            >notary-transaction-contract (6c)</a
                        >
                    </li>
                    <li>
                        <a
                            [routerLink]="[
                                '/notary-transaction-contract-summary'
                            ]"
                            routerLinkActive="router-link-active"
                            target="_blank"
                            rel="noopener noreferrer"
                            >notary-transaction-contract-summary (6f)</a
                        >
                    </li>
                    <li>
                        <a
                            [routerLink]="['/notary-transaction-start']"
                            routerLinkActive="router-link-active"
                            target="_blank"
                            rel="noopener noreferrer"
                            >notary-transaction-start (5e)</a
                        >
                    </li>
                    <li>
                        <a
                            [routerLink]="['/citizen-transaction-acceptance']"
                            routerLinkActive="router-link-active"
                            target="_blank"
                            rel="noopener noreferrer"
                            >citizen-transaction-acceptance (9a, 9b)</a
                        >
                    </li>
                    <li>
                        <a
                            [routerLink]="[
                                '/citizen-transaction-acceptance-list'
                            ]"
                            routerLinkActive="router-link-active"
                            target="_blank"
                            rel="noopener noreferrer"
                            >citizen-transaction-acceptance-list (9c, 9d, 9e,
                            9f)</a
                        >
                    </li>
                    <li>
                        <a
                            [routerLink]="['/citizen-property-info']"
                            routerLinkActive="router-link-active"
                            target="_blank"
                            rel="noopener noreferrer"
                            >citizen-property-info (8a, 8b)</a
                        >
                    </li>
                </ul>
            </ng-template>
        </li>
        <li [ngbNavItem]="4">
            <a ngbNavLink>Bottom</a>
            <ng-template ngbNavContent>
                <p>
                    Sed commodo, leo at suscipit dictum, quam est porttitor
                    sapien, eget sodales nibh elit id diam. Nulla facilisi.
                    Donec egestas ligula vitae odio interdum aliquet. Duis
                    lectus turpis, luctus eget tincidunt eu, congue et odio.
                    Duis pharetra et nisl at faucibus. Quisque luctus pulvinar
                    arcu, et molestie lectus ultrices et. Sed diam urna, egestas
                    ut ipsum vel, volutpat volutpat neque. Praesent fringilla
                    tortor arcu. Vivamus faucibus nisl enim, nec tristique ipsum
                    euismod facilisis. Morbi ut bibendum est, eu tincidunt odio.
                    Orci varius natoque penatibus et magnis dis parturient
                    montes, nascetur ridiculus mus. Mauris aliquet odio ac lorem
                    aliquet ultricies in eget neque. Phasellus nec tortor vel
                    tellus pulvinar feugiat.
                </p>
            </ng-template>
        </li>
    </ul>

    <div [ngbNavOutlet]="nav" class="m-5"></div>
</div>
